import React, {Component} from 'react';
import generateCrumbs from '../../utils/reports/generateCrumbs';
import __ from '../../utils/translator';
import ReportBreadcrumb from './ReportBreadcrumb';
import AccordionPrefix from './AccordionPrefix';
import Accordion from './Accordion';
import AccordionTitle from './AccordionTitle';
import AccordionItemContainer from './AccordionItemContainer';
import AccordionItem from './AccordionItem';
import ThemeStatus from '../ThemeStatus';
import ModalFullscreenActions from '../../flux/ModalFullscreenActions';
import Loading from './Loading';
import withUserReportData from '../../hoc/withUserReportData';
import RenderOnTablet from "../responsive/RenderOnTablet";
import generateReportUrl from "../../utils/reports/generateReportUrl";
import { withTheme } from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import RenderOnMobile from "../responsive/RenderOnMobile";
import { ItemSmallLabel, TitleSmallLabel } from "./ReportsLabels";
import NoResults from "../NoResults";
import getRedirectProps from "../../utils/reports/getRedirectProps";
import ReportStore from "../../flux/reports/ReportStore";

class UserReport extends Component {
  static defaultProps = {
    username: null,
    storeName: null,
    storeThronName: null,
    isActive: false,
  };

  state = {
    // from HOC
    isLoading: this.props.isLoading,
    themes: this.props.themes,
    themesCompleted: this.props.themesCompleted,
    themesCount: this.props.themesCount,

    username: this.props.username,
    storeName: this.props.storeName,
    storeThronName: this.props.storeThronName,
    isActive: this.props.isActive,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.isLoading !== prevState.isLoading ||
      nextProps.themes !== prevState.themes ||
      nextProps.username !== prevState.username ||
      nextProps.storeName !== prevState.storeName
    ) {
      return nextProps;
    }

    return null;
  }

  render() {
    return (
      <div>
        <RenderOnTablet>
          <ReportBreadcrumb crumbs={generateCrumbs(this.props.match.params, __, this.state.storeName, this.state.username)} />

          <AccordionPrefix columns={['50%', '20%', '30%']}>
            <span>{__('Name')}</span>
            <span>{__('Completed theme')}</span>
            <span />
          </AccordionPrefix>
        </RenderOnTablet>

        <Accordion>
          <div style={{ boxShadow: themeResponsiveProperty('0px 0px .25rem rgba(0, 0, 0, 0.25)', null)(this.props) }}>
          <AccordionTitle
            to="#"
            isExpanded={true}
            columns={themeResponsiveProperty(['45%', '40%', '15%'], ['50%', '20%', '30%'])(this.props)}>
            <TitleSmallLabel style={{textTransform: 'capitalize'}}>
              {this.state.username}
            </TitleSmallLabel>

            <RenderOnMobile>
              <ItemSmallLabel>
                {__('Completed Themes')}
              </ItemSmallLabel>
            </RenderOnMobile>

            <TitleSmallLabel style={{textAlign: themeResponsiveProperty('right', null)(this.props)}}>
              {this.state.themesCompleted}/{this.state.themesCount}
            </TitleSmallLabel>

            <div />
          </AccordionTitle>

          <AccordionItemContainer>
            {this.state.themes.map(theme => (
              <AccordionItem
                key={theme.id}
                to="#"
                columns={themeResponsiveProperty(['70%', '30%'], ['50%', '20%', '30%'])(this.props)}
                style={{borderBottom: 0}}
              >
                <ItemSmallLabel>
                  {theme.name}
                </ItemSmallLabel>
                <ItemSmallLabel style={{
                  display: themeResponsiveProperty('flex', null)(this.props),
                  justifyContent: themeResponsiveProperty('flex-end', null)(this.props),
                  color: theme.status === 'theme_completed' ? '#489a46' : null
                }}>
                  <ThemeStatus status={theme.status} />
                </ItemSmallLabel>

                <RenderOnTablet>
                  <span />
                </RenderOnTablet>
              </AccordionItem>
            ))}

            {this.state.isLoading && (
              <AccordionItem to="#" style={{ justifyContent: 'center', }}>
                <Loading />
              </AccordionItem>
            )}

            {this.state.isLoading === false && this.state.themes.length === 0 && (
              <NoResults message={__('No results for the selected user.')} />
            )}
          </AccordionItemContainer>
          </div>
        </Accordion>
      </div>
    );
  }
}

export default withUserReportData(withTheme(UserReport));
